import React, { useCallback, useEffect, useState } from 'react'
import {
  Box,
  Paper,
  Typography,
  Grid,
  Button,
  Divider,
  Tabs,
  Tab,
  CircularProgress,
} from '@mui/material'
import { Send } from '@mui/icons-material'
import PrimeTable from '../../../components/PrimeTable'
import { metodoPrograma } from '../../../components/api'
import { setSuccess } from '../../../components/alerts'
import CardStatus from '../components/CardStatus'
import CardTipoEnvio from '../components/CardTipoEnvio'
import CardPeriodo from '../components/CardPeriodo'
import CardProgresso from '../components/CardProgresso'
import CardTotalPessoas from '../components/CardTotalPessoas'

const TabPanel = ({ children, value, index }) => {
  return (
    <div hidden={value !== index}>
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  )
}

const DetalheCampanha = ({ dados }) => {
  const [tab, setTab] = useState(0)
  const [monitorando, setMonitorando] = useState(false)
  const [mensagem, setMensagem] = useState('')
  const [dsAssunto, setDsAssunto] = useState('')

  const processaMensagem = useCallback(() => {
    metodoPrograma('processaCampanha', {
      idCampanha: dados?.idCampanha,
    }).then((res) => {
      if (res.status) {
        setSuccess('Processamento iniciado.')
        setMonitorando(true)
      }
    })
  }, [dados?.idCampanha])

  const getMensagem = useCallback(() => {
    if (!dados?.idCampanha) return

    metodoPrograma('getMensagem', {
      idCampanha: dados.idCampanha,
    }).then((res) => {
      if (res.status) {
        setMensagem(res.dsMensagem)
        setDsAssunto(res.dsAssunto)
      }
    })
  }, [dados?.idCampanha])

  useEffect(() => {
    getMensagem()
  }, [getMensagem])

  return (
    <Box sx={{ p: 0 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={2.4}>
          <CardTotalPessoas dados={dados} />
        </Grid>

        <Grid item xs={12} sm={6} md={2.4}>
          <CardStatus dados={dados} />
        </Grid>

        <Grid item xs={12} sm={6} md={2.4}>
          <CardTipoEnvio dados={dados} />
        </Grid>

        <Grid item xs={12} sm={6} md={2.4}>
          <CardPeriodo dados={dados} />
        </Grid>

        <Grid item xs={12} sm={6} md={2.4}>
          <CardProgresso dados={dados} monitorando={monitorando} />
        </Grid>
        <Grid item xs={12} md={7.2}>
          <Paper variant="outlined" sx={{ p: 2, borderRadius: 3 }}>
            <Tabs
              value={tab}
              onChange={(e, value) => setTab(value)}
              sx={{ borderBottom: 1, borderColor: 'divider' }}
            >
              <Tab label="Pacientes Vinculados" />
              <Tab label="Mensagens Enviadas" />
            </Tabs>

            {/* Aba Pacientes */}
            <TabPanel value={tab} index={0}>
              <PrimeTable
                codigo="CtrlGestaoCampanha"
                action="listaCliente"
                rows={10}
                habSearch
                parametros={{
                  idCampanha: dados?.idCampanha,
                }}
                head={['Nome', 'Obtenção', 'Telefone', 'Email', 'Status']}
                line={(item) => [
                  item?.[1],
                  item?.[4],
                  item?.[3],
                  item?.[2],
                  item?.[5],
                ]}
              />
            </TabPanel>

            <TabPanel value={tab} index={1}>
              <PrimeTable
                codigo="CtrlGestaoCampanha"
                action="listaMensagensEnviadas"
                rows={10}
                habSearch
                parametros={{
                  idCampanha: dados?.idCampanha,
                }}
                head={['Data/Hora', 'Total Envios', 'Erros']}
                line={(item) => [item[2], item[3], item[4]]}
                collumnsDateHour={[0]}
              />
            </TabPanel>
          </Paper>
        </Grid>

        {/* Informações da Campanha */}
        <Grid item xs={12} md={4.8}>
          <Paper variant="outlined" sx={{ p: 2, borderRadius: 3 }}>
            <Typography variant="h6" gutterBottom>
              Informações
            </Typography>

            <Divider sx={{ mb: 2 }} />

            <Typography variant="subtitle2" color="text.secondary">
              Título
            </Typography>

            <Typography gutterBottom>{dados?.nmCampanha}</Typography>

            <Typography variant="subtitle2" color="text.secondary">
              Assunto:
            </Typography>

            <Typography gutterBottom>{dsAssunto}</Typography>

            <Typography
              variant="subtitle2"
              color="text.secondary"
              sx={{ mt: 2 }}
            >
              Conteúdo da Mensagem
            </Typography>

            <Paper
              variant="outlined"
              sx={{
                p: 2,
                mt: 1,
                mb: 2,
                bgcolor: '#f9f9f9',
                minHeight: 140,
                whiteSpace: 'pre-wrap',
              }}
            >
              {mensagem}
            </Paper>
            <Button
              variant="contained"
              fullWidth
              disabled={monitorando}
              startIcon={
                monitorando ? (
                  <CircularProgress size={18} thickness={5} color="inherit" />
                ) : (
                  <Send />
                )
              }
              onClick={processaMensagem}
            >
              {monitorando ? 'Processando...' : 'Enviar Mensagens'}
            </Button>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  )
}

export default DetalheCampanha
